import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getBookingAgentCarrierList(params) {
  return request({
    url: URL.partner.bookingAgentCarrier,
    method: 'get',
    params
  })
}

export function saveBookingAgentCarrier(data) {
  return request({
    url: URL.partner.bookingAgentCarrier,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function saveBookingAgentCarrierBatch(data) {
  return request({
    url: URL.partner.bookingAgentCarrierBatch,
    method: 'post',
    data
  })
}

export function delBookingAgentCarrier(uuid) {
  return request({
    url: URL.partner.bookingAgentCarrier + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

export function delBookingAgentCarrierBatch(data) {
  return request({
    url: URL.partner.bookingAgentCarrierBatch,
    method: 'delete',
    data
  })
}
